module.exports = __webpack_public_path__ + "img/39fd128.jpg";